import { Box } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";

export const HeaderButtonsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  gap: 8px;
  width: 107px;
  @media (max-width: 768px) {
    width: 97px;
  }
`;

export const TabButton = styled.button<{ isActive: boolean }>`
  flex: 1;
  padding: 8px 16px;
  border-radius: 24px;
  border: ${(props) =>
    props.isActive ? "none" : "1px solid var(--line-primary-n-200, #E7E7F0)"};
  background: ${(props) =>
    props.isActive
      ? "var(--text-primary-n-600, #040222)"
      : "var(--background-white-n-0, #FFF)"};
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => (props.isActive ? "500" : "400")};
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: ${(props) =>
    props.isActive ? "#FFFFFF" : "var(--text-primary-n-600, #040222)"};
  &:active {
    transform: translateY(1px);
  }
`;

export const ContentContainer = styled(Box)`
  width: 100%;
`;
